import {guard} from '@acng/frontend-rubicon';
import {AttributeLink} from '@acng/frontend-stargazer';
import {IMAGE_FORMAT} from '../model/image.js';

/**
 * @group DOM Attribute
 */
const name = 'image-format';

ASSERT: {
  AttributeLink(name, (element, value) => {
    guard(value, IMAGE_FORMAT, `[${name}=${value}]`);
  });
}

export {name as IMAGE_FORMAT};
